<script>
    // Ajouter des scripts ou des importations ici si nécessaire
  </script>
  
  <main class="vh-100 flex items-center justify-center">
    <h1 class="f1">Coming Soon</h1>
  </main>
  
  <style>
    main {
      background: linear-gradient(to bottom right, #2c7cc9 50%, #d1e51e);
      color: white;
    }
  </style>